module.exports = __webpack_public_path__ + "static/img/shisi.b9d0f0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shisi.png
// module id = H6+x
// module chunks = 1